import Modal from 'react-modal'
import UndiruvchiDashboardModalStyle from './UndiruvchiDashboardModalStyle'
import { useEffect, useState } from 'react'
import { customFuncsApi } from '../../../api'
import { useSelector } from 'react-redux'
import Spinner from '../../Spinner'
import numberWithSpaces from '../../../helpers/numberWithSpaces'

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		borderRadius: 15,
		border: 'none',
		overflowX: 'auto',
		...(window.innerWidth <= 640 ? { height: '90%' } : {}),
		zIndex: 1000,
	},
	overlay: {
		background: '#00000099',
		zIndex: 1000,
	},
}
const UndiruvchiDashboardListModal = ({
	isOpenModal,
	setIsOpenModal,
	totalEndpoint,
	openUndiruvchiModal,
}) => {
	const { value: undiruvchiList } = useSelector((state) => state.undiruvchiList)
	const InitialData = undiruvchiList.map((el) => ({
		U_Dunner: el.EmployeesInfo.EmployeeID,
		FirstName: el.EmployeesInfo.FirstName,
		LastName: el.EmployeesInfo.LastName,
		ClientCount: 0,
		PaidTotal: 0,
	}))

	const [isLoading, setIsLoading] = useState(false)
	const [data, setData] = useState(InitialData)

	useEffect(() => {
		const fetchData = async () => {
			setIsLoading(true)
			try {
				const responses = await Promise.all(
					InitialData.map((item) =>
						customFuncsApi.get(`/${totalEndpoint}`, {
							params: {
								U_Dunner: item.U_Dunner,
							},
						}),
					),
				)

				const apiData = responses.map((res) => res.data)

				setData((prev) =>
					prev.map((item, index) => ({
						...item,
						ClientCount: apiData[index].value[0].ClientCount ?? 0,
						PaidTotal: apiData[index].value[0].PaidTotal ?? 0,
					})),
				)
			} catch (error) {
				console.error('API fetch error:', error)
			} finally {
				setIsLoading(false)
			}
		}
		fetchData()
	}, [])

	return (
		<Modal
			isOpen={isOpenModal}
			onRequestClose={() => setIsOpenModal(false)}
			style={customStyles}
			contentLabel="Example Modal"
			ariaHideApp={false}
		>
			<UndiruvchiDashboardModalStyle>
				<div className="card">
					<p className="title">Выберите коллектора</p>
				</div>
				{isLoading ? (
					<Spinner />
				) : (
					<div className="overflow-auto max-h-[calc(60vh)]">
						<table className="w-full border-collapse bg-white text-sm">
							<thead>
								<tr className="bg-gray-50">
									<th className="border border-gray-200 px-3 py-2 text-left font-medium text-gray-600 text-xs uppercase">
										Имя
									</th>
									<th className="border border-gray-200 px-3 py-2 text-left font-medium text-gray-600 text-xs uppercase">
										Фамилия
									</th>
									<th className="border border-gray-200 px-3 py-2 text-left font-medium text-gray-600 text-xs uppercase">
										Должники
									</th>
									<th className="border border-gray-200 px-3 py-2 text-left font-medium text-gray-600 text-xs uppercase">
										Общая сумма выплаченных денег
									</th>
								</tr>
							</thead>
							<tbody>
								{data.map((row, index) => (
									<tr
										key={index}
										className="bg-white hover:bg-gray-100 cursor-pointer transition-colors"
										onClick={() => openUndiruvchiModal(row.U_Dunner)}
									>
										<td className="border border-gray-200 px-3 py-2">
											{row.FirstName || '—'}
										</td>
										<td className="border border-gray-200 px-3 py-2">
											{row.LastName || '—'}
										</td>
										<td className="border border-gray-200 px-3 py-2">
											{numberWithSpaces(row.ClientCount || 0)}
										</td>
										<td className="border border-gray-200 px-3 py-2">
											${numberWithSpaces(row.PaidTotal || 0)}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)}
			</UndiruvchiDashboardModalStyle>
		</Modal>
	)
}

export default UndiruvchiDashboardListModal
